/**
 * Collection of helper function for classes
 */
import xml2js from 'xml2js'
import JsSIP from 'jssip'
import Browser from 'bowser'
import EmbeddedLocalStorage from '@/api/embedded'

/**
 * Converts strings like '00:12:45' to seconds number
 */
export function DurationToSec (dur) {
  if (!dur) return 0
  if (!/^\d\d(:\d\d){2}$/.test(dur)) return 0
  return dur.split(':', 3).reverse()
    .reduce((sec, v, i) => sec + ~~v * Math.pow(60, i), 0)
}

/**
 * If string is Asterisk '<nil>' string (in AMI event for ex.)
 * then return empty string
 */
export function AstNilString (val) {
  if (typeof val === 'number') return val
  if (!val || val === '<nil>') {
    return ''
  }
  return val
}

/**
 * Browser compatibility test
 * Returns true is compatible
 *
 * minimum compatibiblity must satisfy at least new
 * Intl.RelativeTimeFormat constructor
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/RelativeTimeFormat#browser_compatibility
 */
export function BrowserCompatible (userAgent, embedded) {
  const browser = Browser.getParser(userAgent)
  const embeddedLocalStorage = EmbeddedLocalStorage.get()
  // Check if it's a WebView on iOS
  const isIOSWebView = /iPhone|iPad|iPod/i.test(userAgent) && !/Safari/i.test(userAgent)
  if (isIOSWebView || embedded || embeddedLocalStorage) {
    // iOS user_agent for webviews is not standard as it does not provide a version which breaks everything
    return true
  } else {
    return !!browser.satisfies({
      chrome: '>71',
      chromium: '>71',
      edge: '>79',
      firefox: '>65',
      opera: '>58',
      safari: '>14',
      samsung: '>12'
    })
  }
}

/**
 * Parse SIP presence XML body
 */
export function ParsePresXML (xmlBody) {
  const result = {
    error: null,
    remote: null,
    local: null,
    state: null
  }
  const opts = {
    trim: true,
    explicitArray: false,
    ignoreAttrs: true
  }
  xml2js.parseString(xmlBody, opts, function (err, res) {
    if (err) {
      result.error = 'failed to parse presence. Invalid XML.'
      return
    }
    try {
      const remote = res['dialog-info'].dialog.remote.identity
      const local = res['dialog-info'].dialog.local.identity
      result.state = res['dialog-info'].dialog.state
      result.remote = JsSIP.URI.parse(remote)
      result.local = JsSIP.URI.parse(local)
    } catch {
      result.error = 'invalid presence XML structure'
    }
  })
  return result
}

/**
 * Get 'P-Asserted-Identity' header from request and
 * return as JsSIP.NameAddrHeader instance or null/undefined
 * if not exists or failed to parse
 */
export function SIPRequestPAI (req) {
  if (!req) {
    return null
  }

  const header = req.getHeader('P-Asserted-Identity')
  if (!header) {
    return null
  }

  return JsSIP.NameAddrHeader.parse(header)
}
